<template>
  <!-- 选择医生弹窗 -->
  <div class="choose-doctor">
    <el-dialog title="选择医生"
               :visible.sync="doctorDialog"
               width="800px"
               class="doctor-box"
               custom-class='xx'
               :modal-append-to-body='false'
               :close-on-click-modal="false"
               :show-close="false">
      <div class="content bb">
        <div class="felx">
          <el-input v-model="keyword"
                    placeholder="医生姓名、擅长、职称、科室"
                    style="width:300px;margin-right:15px"
                    @input="inputSearch"></el-input>
          <el-button type="primary"
                     @click="getDoctorList">查询</el-button>
        </div>
        <div class="list">
          <div class="box flex bb"
               v-for="item in doctorList"
               :key="item.doctor_id">
            <el-checkbox v-model="item.checked"></el-checkbox>
            <img :src="item.head_img"
                 alt="">
            <div>
              <div class="d1"><span>{{item.doctor_name}}</span><span>{{item.title}}</span><span>图文：</span><span class="red">￥{{item.reception_price}}</span></div>
              <div class="d2"><span>{{item.province_name}}</span><span>{{item.city_name}}</span></div>
              <div class="d3"><span>擅长方向：</span><span class="s2">{{item.be_good_at}}</span></div>
              <div class="d3"><span>个人简介：</span><span class="s2">{{item.introduction}}</span></div>
            </div>
          </div>
          <div v-show="doctorList.length==0"
               style="margin:20px auto">暂无搜索结果</div>
        </div>

      </div>
      <div style="text-align:right;padding:0 50px 20px 0">
        <span slot="footer"
              class="dialog-footer">
          <el-button type="info"
                     @click="close"
                     style="width:92px">取消</el-button>
          <el-button type="primary"
                     @click="submit"
                     style="width:92px">保 存</el-button>
        </span>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import common from '../../../../api/common.js';
export default {
  name: 'firstChild',
  data() {
    return {
      doctorDialog: true,
      keyword: '',
      doctorList: []
    };
  },
  components: {},
  created() {},
  methods: {
    //搜索医生列表
    inputSearch() {
      if (!this.keyword) {
        return false;
      }
      this.getDoctorList();
    },
    getDoctorList() {
      if (!this.keyword) {
        this.$message.error('请输入医生信息！');
        return false;
      }
      common.searchDoctorList({ keyword: this.keyword }).then((res) => {
        let list = res.data.list;
        list.forEach((ele) => {
          ele.checked = false;
        });
        this.doctorList = list;
      });
    },
    close() {
      this.$emit('close');
    },
    submit() {
      let arr = this.doctorList.filter((ele) => {
        return ele.checked == true;
      });
      if (!arr || arr.length == 0) {
        this.$message.warning('您还没有选择医生');
        return;
      }
      let length = arr.length;
      if (length > 3) {
        this.$message.error('最多选择3个医生！');
        return;
      }
      this.$emit('confirmDoctor',arr)
      this.close()
      // this.doctorList = [];
      // this.keyword = '';
    }
  }
};
</script>

<style lang='scss' scoped>
.choose-doctor {
  .doctor-box {
    .content {
      padding: 15px;
      .felx{
        text-align: left;
      }
    }
    .list {
      height: 400px;
      overflow: auto;
      .box {
        margin: 15px 0;
        padding: 10px;
        border-radius: 10px;
        border: 1px solid #cccccc;
        .el-checkbox {
          align-self: center;
        }
        img {
          width: 80px;
          height: 80px;
          border-radius: 5px;
          margin-right: 10px;
          margin-left: 10px;
        }
        .d1 {
          margin-bottom: 5px;
          line-height: 25px;
          text-align: left;
          span {
            margin-right: 10px;
          }
        }
        .d2 {
          margin-bottom: 5px;
          line-height: 25px;
          text-align: left;
          span {
            color: #a0918c;
          }
        }
        .d3 {
          text-align: left;
          line-height: 25px;
          .s2 {
            color: #71737c;
          }
        }
      }
    }
  }
}
</style>
